import * as React from 'react';
import moment from 'moment-timezone';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import FontAwesomeIcon from 'react-fontawesome';
import { Store, WorkingHoursType } from './types';
import { overrideWorkingHours } from './actions/Actions';

const WorkingHours: React.FC<RouteComponentProps> = () => {
    const dispatch = useDispatch();
    const [currentDate, setCurrentDate] = React.useState(moment());
    const [{ openingDateTime, closingDateTime }] = useSelector(
        ({ app }: Store) => app.workingHours
    );

    const tickInterval = React.useRef<number>();

    const getTime = React.useCallback((dt: string) => dt.slice(0, -6), []);

    const openTime = moment(getTime(openingDateTime));
    const closeTime = moment(getTime(closingDateTime));
    const isAfterOpenTime = currentDate.isSameOrAfter(openTime);

    const handleWorkingHoursOverride = React.useCallback(
        (type: WorkingHoursType) => () => {
            dispatch(overrideWorkingHours(type));
        },
        [dispatch]
    );

    React.useEffect(() => {
        tickInterval.current = window.setInterval(() => {
            setCurrentDate(currentDate.clone().add(1, 's'));
        }, 1000);

        return () => {
            clearInterval(tickInterval.current);
            tickInterval.current = null;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='working-hours'>
            <div className='wrapper'>
                <div className='current-date'>
                    {currentDate.format('dddd DD/M/YYYY')}
                </div>
                <div className='hours'>
                    {openTime.format('HH:mm')} - {closeTime.format('HH:mm')}
                </div>
                <div className='current-time'>
                    <FontAwesomeIcon name='clock-o' className='clock' />
                    {currentDate.format('HH:mm')}
                </div>
                <div className='actions'>
                    <button
                        type='button'
                        className='open'
                        onClick={handleWorkingHoursOverride(
                            WorkingHoursType.OPEN_EARLY
                        )}
                        disabled={isAfterOpenTime}>
                        ΑΝΟΙΓΜΑ
                    </button>
                    <button
                        type='button'
                        className='extend'
                        onClick={handleWorkingHoursOverride(
                            WorkingHoursType.STAY_OPEN_LATE
                        )}>
                        ΠΑΡΑΤΑΣΗ
                    </button>
                    <button
                        type='button'
                        className='close'
                        onClick={handleWorkingHoursOverride(
                            WorkingHoursType.CLOSE_STORE
                        )}
                        disabled={
                            !(isAfterOpenTime && currentDate.isBefore(closeTime))
                        }>
                        ΚΛΕΙΣΙΜΟ
                    </button>
                </div>
            </div>
        </div>
    );
};

export default WorkingHours;
